import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SignOutButton } from './SignOutButton.js';
const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    fontFamily: 'var(--font-family-base, system-ui, sans-serif)',
    background: 'var(--color-bg-page, #FAFBFC)',
    color: 'var(--color-text-primary, #1A1A2E)',
};
const headerStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '1em',
    padding: 'var(--space-sm, 0.5em) var(--space-md, 1em)',
    background: '#FFFFFF',
    borderBottom: '1px solid var(--color-border, #E5E7EB)',
};
const mainStyle = { flex: '1 1 auto', padding: 'var(--space-md, 1em)' };
const footerStyle = {
    padding: 'var(--space-sm, 0.75em) var(--space-md, 1em)',
    borderTop: '1px solid var(--color-border, #E5E7EB)',
};
const titleStyle = {
    margin: 0,
    fontSize: 'var(--font-size-heading-sm, 1.25rem)',
    fontWeight: 'var(--font-weight-semibold, 600)',
    color: 'var(--color-text-primary, #1A1A2E)',
};
const logoStyle = {
    height: 28,
    width: 'auto',
};
const headerLeftStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75em',
};
/** Renders the page shell with header/main/footer landmarks. */
export function AppLayout({ title, header, headerRight, children, footer, className, }) {
    return (_jsxs("div", { className: className, style: containerStyle, children: [_jsx("header", { style: headerStyle, children: header ?? (_jsxs(_Fragment, { children: [_jsxs("div", { style: headerLeftStyle, children: [_jsx("a", { href: "/", "aria-label": "Home", style: { display: 'flex', alignItems: 'center' }, children: _jsx("img", { src: "/logo.svg", alt: "HitClays", style: logoStyle }) }), title !== undefined ? _jsx("h1", { style: titleStyle, children: title }) : null] }), _jsxs("div", { style: headerLeftStyle, children: [headerRight !== undefined ? _jsx("div", { children: headerRight }) : null, _jsx(SignOutButton, {})] })] })) }), _jsx("main", { style: mainStyle, children: children }), footer !== undefined ? _jsx("footer", { style: footerStyle, children: footer }) : null] }));
}
//# sourceMappingURL=AppLayout.js.map